import React from 'react'
import './styles.css'
export default function CustomButtom({ child, className, style }) {
    return (
        <button className={className} style={style}>
            {child}
        </button>
    )
}
